import { render, staticRenderFns } from "./virtualList.vue?vue&type=template&id=0eb7bdfe&"
import script from "./virtualList.vue?vue&type=script&lang=js&"
export * from "./virtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/virtualList/virtualList.vue"
export default component.exports